import type { GridColDef } from "@mui/x-data-grid-premium";
import React from "react";
import type { PermissionName } from "../../../../clients/graphqlTypes.js";
import { DecisionWizardButtons } from "../../projects/quote-trees.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
  canEdit: boolean;
  projectId: string;
  quote: {
    id: string;
    owningSystemOrganisationId: string;
    viewerPermissions: PermissionName[];
  };
}

export function createDecisionWizardButtonsColumn<
  T extends DocDataGrid_ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "decisionWizardButtons",
    headerName: options.headerName,
    width: 40,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      return (
        <DecisionWizardButtons
          projectId={options.projectId}
          quote={options.quote}
          item={params.row.item}
          disabled={!options.canEdit}
        />
      );
    },
  };
}
